import React, {Fragment} from "react";
import {Col, Form, Row} from "reactstrap";
import SearchInputBox from "./SearchInputBox";
import {ViewConfig} from "../views/ViewConfig";
import SFXButtonComponent from "./SFXButtonComponent";
import DropdownComponent from "./DropdownComponent";
import Select from "react-select";
import 'react-select/dist/react-select.min.css';
import DatePickerWithLabel from "./DatePickerWithLabel";

const CONFIG_PANEL_ROW = {
  className: "search-input-group",
  noGutters: true
};
const CONFIG_INPUT_COL = {
  xs: {size: 12},
  sm: {size: 12},
  md: {size: 10},
  lg: {size: 10},
  xl: {size: 10},
};
const CONFIG_BUTTON_COL = {
  xs: {size: 12},
  sm: {size: 12},
  md: {size: 2},
  lg: {size: 2},
  xl: {size: 2},
  style: {
    paddingRight: "0px"
  }
};

const stateCache = {};
const getStateKey = function () {
  let href = window.location.href;
  href = href.replace("#", "");
  return href;
};
const saveState = (stateKey, state) => {
  stateCache[stateKey] = {...state};
};
const getState = (stateKey) => {
  return stateCache[stateKey];
};


export default class SearchInputGroup extends React.Component {

  constructor(props) {
    super(props);
    this.valuesJsonString = undefined;

    this.stateKey = getStateKey();
    let restoreState = getState(this.stateKey);

    if (restoreState) {
      this.state = restoreState;
    } else {
      this.state = {
        values: this.getDefaultValues()
      };
    }

    this.handleChange = this.handleChange.bind(this);
    this.performSubmitEvent = this.performSubmitEvent.bind(this);
  }

  componentWillUnmount() {
    if (this.stateKey) {
      saveState(this.stateKey, this.state);
    }
  }

  getValues() {

    let values = this.state.values;

    if (this.props.searchFields) {
      this.props.searchFields.forEach(searchField => {
        if (!values[searchField.searchKey]) {
          values[searchField.searchKey] = "";
        }
      });
    }

    return values;
  }

  getDefaultValues() {

    let values = {};

    if (this.props.searchFields) {
      this.props.searchFields.forEach(searchField => {
        values[searchField.searchKey] = searchField.defaultValue;
      });
    }

    return values;
  }

  handleChange(event) {
    this.handleValueChange(event.target.id, event.target.value);
  }

  handleValueChange(key, value) {

    let newValues = {...this.state.values};
    newValues[key] = value;

    this.setState({
      values: newValues
    }, this.scheduleSubmit);
  }

  scheduleSubmit() {
    if (this.submitScheduled) clearTimeout(this.submitScheduled);
    this.submitScheduled = setTimeout(this.performSubmitEvent, 333);
  }

  performSubmitEvent(event) {
    if (event && event.preventDefault) event.preventDefault();
    this.submitScheduled = undefined;

    let valuesJsonString = JSON.stringify(this.state.values);
    if (this.valuesJsonString === valuesJsonString) return;
    this.valuesJsonString = valuesJsonString;

    if (this.props.onSubmit) this.props.onSubmit();
  }

  render() {
    let renderButton = this.props.searchButton || false;
    return <Form onSubmit={this.performSubmitEvent}>
      <Row {...CONFIG_PANEL_ROW}>
        {
          renderButton
            ? this.renderWithButton()
            : this.renderWithoutButton()
        }
      </Row>
    </Form>
  }

  renderWithoutButton() {
    return <Col xs={12}>
      <Row {...ViewConfig.SEARCH_GROUP_ROW_PROPS}>
        {this.renderSearchFields()}
      </Row>
    </Col>
  }

  renderWithButton() {
    return <Fragment>
      <Col {...CONFIG_INPUT_COL}>
        <Row {...ViewConfig.SEARCH_GROUP_ROW_PROPS}>
          {this.renderSearchFields()}
        </Row>
      </Col>
      <Col {...CONFIG_BUTTON_COL}>
        <SFXButtonComponent type="submit" color="success"><i className="fa fa-search"></i> Search</SFXButtonComponent>
      </Col>
    </Fragment>
  }

  renderSearchFields() {
    return this.props.searchFields && this.props.searchFields.map(searchField => {
      let value = this.state.values[searchField.searchKey] || "";
      if (searchField.type === "select")
        return this.renderDropdown(searchField, value);
      else if (searchField.type === "multi-select")
        return this.renderMultiSelect(searchField, value);
      else if (searchField.type === "date")
        return this.renderDateFieldV2(searchField, value);
      else
        return this.renderTextField(searchField, value);
    });
  }

  renderTextField(searchField, value) {
    return <SearchInputBox key={searchField.searchKey}
                           type="text" id={searchField.searchKey} name={searchField.searchKey}
                           placeholder={searchField.placeholder}
                           value={value} onChange={this.handleChange}
    />
  }

  renderDateField(searchField, value) {
    return <SearchInputBox key={searchField.searchKey}
                           type="date" id={searchField.searchKey} name={searchField.searchKey}
                           placeholder={searchField.placeholder}
                           value={value} onChange={this.handleChange}
                           label={searchField.label}
    />
  }

  renderDateFieldV2(searchField, value) {

    return <DatePickerWithLabel
      key={searchField.searchKey}
      label={searchField.label}
      placeholder={searchField.placeholder}
      value={value}
      onChange={(value) => this.handleValueChange(searchField.searchKey, value)}
    />
  }

  renderDropdown(searchField, value) {
    let dropdownProps = {...searchField};
    delete dropdownProps.searchKey;
    delete dropdownProps.placeholder;
    delete dropdownProps.type;

    return <Col {...ViewConfig.SEARCH_BOX_PROPS} key={searchField.searchKey}>
      <DropdownComponent
        key={searchField.searchKey}
        {...dropdownProps}
        value={value}
        onChange={(option) => {
          if (option === null) {
            this.handleValueChange(searchField.searchKey, "");
          }
          else
            this.handleValueChange(searchField.searchKey, option[searchField.optionValue]);

        }
        }
      />
    </Col>
  }

  renderMultiSelect(searchField, value) {
    let dropdownProps = {...searchField};
    delete dropdownProps.searchKey;
    delete dropdownProps.type;

    let options = dropdownProps.options || [];

    return <Col {...ViewConfig.SEARCH_BOX_PROPS} key={searchField.searchKey}>
      <Select options={options}
              multi
              value={value}
              onChange={(values) => {

                let selectedValues = "";
                values.forEach((value, index) => {
                  if (index > 0) selectedValues += ",";
                  selectedValues += value.value;
                });


                this.handleValueChange(searchField.searchKey, selectedValues);
              }}
              placeholder={dropdownProps.placeholder}
      />
    </Col>
  }
}
